import React from 'react';
import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import TritonLogo from '../../assets/triton_logo_150_transparent.png';
import { FluxButton } from '@meltwater/flux-web-components-react';

const ErrorPage = ({ title, message, retryAction }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f3f4f6' }}>
      <Container maxWidth="md">
        <Paper 
          elevation={3} 
          style={{ 
            padding: '40px', 
            borderRadius: '14px', 
            maxWidth: '480px', 
            width: '100%',
            margin: '0 auto',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
            border: '1px solid #d1d5db'
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <img src={TritonLogo} width={180} alt='Triton' style={{ marginBottom: '20px' }} />
            
            <PowerOffIcon sx={{ fontSize: 80, color: '#ff0000', my: 3 }} />
            
            <Typography variant="h3" component="h1" gutterBottom style={{ color: '#333' }}>
              {title || 'Oops! Something went wrong'}
            </Typography>
            
            <Typography 
              variant="h6" 
              style={{ 
                fontSize: '1.2rem',
                maxWidth: '500px',
                margin: '0 auto 2rem auto',
                color: '#666',
                lineHeight: '1.6'
              }}
            >
              {message || 'We\'re having trouble connecting to our servers.'}
            </Typography>
            
            <Grid container spacing={3} justifyContent="center" sx={{ mt: 3 }}>
              <Grid item>
                <FluxButton 
                  tint='primary'
                  type='filled'
                  onClick={retryAction || (() => window.location.reload())}
                >
                  Try Again
                </FluxButton>
              </Grid>
              <Grid item>
                <FluxButton 
                  tint='secondary'
                  type='outlined'
                  component="a" 
                  href="https://meltwater.slack.com/archives/C066HEYFYH5"
                  target="_blank"
                >
                  Contact Support
                </FluxButton>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default ErrorPage;
